import { ListClassKey, StyleRules, Theme } from '@material-ui/core';

type ListStyles = Partial<StyleRules<ListClassKey>>;

export const listStyles = (theme: Theme): ListStyles => ({
  root: {
    padding: theme.spacing(0),
  },
});
